/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import TextContainer from "../../../../components/Container/TextContainer";
import Layout from "../../../Layouts/Layout";
import guidebookOverviewPageStyle from "../../Generic/GenericGuidebookPage/guidebookOverviewPageStyle";
import CardLinked from "../../../../components/Cards/CardLinked/CardLinked";
import * as guidebookDivorceContent from "./GuidebookDivorceCardContent";
import Grid from "@mui/material/Grid";
import { Helmet } from "react-helmet-async";
import Container from "../../../../components/Container/Container";
import Typography from "@mui/material/Typography";
import { gaSet } from "../../../../services/googleAnalyticsService";

export default function GuidebookFamilyLawOverview() {
  const title = "Ratgeber Scheidung | Legalbird";
  gaSet({ title: title });

  return (
    <Layout backgroundType={"serviceworld"}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Container>
        <Typography variant={"h1"} sx={guidebookOverviewPageStyle.overviewHeading}>
          Ratgeber Familienrecht
        </Typography>
      </Container>
      <TextContainer>
        <Grid container spacing={5} sx={{
          alignItems: "stretch"
        }}>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookDivorceContent.guidebookDivorceCosts.linkTo}
              image={guidebookDivorceContent.guidebookDivorceCosts.image}
              headline={guidebookDivorceContent.guidebookDivorceCosts.headline}
              text={guidebookDivorceContent.guidebookDivorceCosts.text}
              altTitle={guidebookDivorceContent.guidebookDivorceCosts.altTitle}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookDivorceContent.guidebookDivorceRequirements.linkTo}
              image={guidebookDivorceContent.guidebookDivorceRequirements.image}
              headline={guidebookDivorceContent.guidebookDivorceRequirements.headline}
              text={guidebookDivorceContent.guidebookDivorceRequirements.text}
              altTitle={guidebookDivorceContent.guidebookDivorceRequirements.altTitle}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookDivorceContent.guidebookAgreedDivorce.linkTo}
              image={guidebookDivorceContent.guidebookAgreedDivorce.image}
              headline={guidebookDivorceContent.guidebookAgreedDivorce.headline}
              text={guidebookDivorceContent.guidebookAgreedDivorce.text}
              altTitle={guidebookDivorceContent.guidebookAgreedDivorce.altTitle}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookDivorceContent.guidebookDivorceImportantTopics.linkTo}
              image={guidebookDivorceContent.guidebookDivorceImportantTopics.image}
              headline={guidebookDivorceContent.guidebookDivorceImportantTopics.headline}
              text={guidebookDivorceContent.guidebookDivorceImportantTopics.text}
              altTitle={guidebookDivorceContent.guidebookDivorceImportantTopics.altTitle}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookDivorceContent.guidebookDivorceDuration.linkTo}
              image={guidebookDivorceContent.guidebookDivorceDuration.image}
              headline={guidebookDivorceContent.guidebookDivorceDuration.headline}
              text={guidebookDivorceContent.guidebookDivorceDuration.text}
              altTitle={guidebookDivorceContent.guidebookDivorceDuration.altTitle}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookDivorceContent.guidebookDivorcePensions.linkTo}
              image={guidebookDivorceContent.guidebookDivorcePensions.image}
              headline={guidebookDivorceContent.guidebookDivorcePensions.headline}
              text={guidebookDivorceContent.guidebookDivorcePensions.text}
              altTitle={guidebookDivorceContent.guidebookDivorcePensions.altTitle}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookDivorceContent.guidebookDivorceProcessCostSupport.linkTo}
              image={guidebookDivorceContent.guidebookDivorceProcessCostSupport.image}
              headline={guidebookDivorceContent.guidebookDivorceProcessCostSupport.headline}
              text={guidebookDivorceContent.guidebookDivorceProcessCostSupport.text}
              altTitle={guidebookDivorceContent.guidebookDivorceProcessCostSupport.altTitle}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookDivorceContent.guidebookDivorceThreeYearsSeparation.linkTo}
              image={guidebookDivorceContent.guidebookDivorceThreeYearsSeparation.image}
              headline={guidebookDivorceContent.guidebookDivorceThreeYearsSeparation.headline}
              text={guidebookDivorceContent.guidebookDivorceThreeYearsSeparation.text}
              altTitle={guidebookDivorceContent.guidebookDivorceThreeYearsSeparation.altTitle}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookDivorceContent.guidebookContentiousDivorce.linkTo}
              image={guidebookDivorceContent.guidebookContentiousDivorce.image}
              headline={guidebookDivorceContent.guidebookContentiousDivorce.headline}
              text={guidebookDivorceContent.guidebookContentiousDivorce.text}
              altTitle={guidebookDivorceContent.guidebookContentiousDivorce.altTitle}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookDivorceContent.guidebookHardshipDivorce.linkTo}
              image={guidebookDivorceContent.guidebookHardshipDivorce.image}
              headline={guidebookDivorceContent.guidebookHardshipDivorce.headline}
              text={guidebookDivorceContent.guidebookHardshipDivorce.text}
              altTitle={guidebookDivorceContent.guidebookHardshipDivorce.altTitle}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookDivorceContent.guidebookAttorneyDuty.linkTo}
              image={guidebookDivorceContent.guidebookAttorneyDuty.image}
              headline={guidebookDivorceContent.guidebookAttorneyDuty.headline}
              text={guidebookDivorceContent.guidebookAttorneyDuty.text}
              altTitle={guidebookDivorceContent.guidebookAttorneyDuty.altTitle}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookDivorceContent.guidebookDivorceAlimony.linkTo}
              image={guidebookDivorceContent.guidebookDivorceAlimony.image}
              headline={guidebookDivorceContent.guidebookDivorceAlimony.headline}
              text={guidebookDivorceContent.guidebookDivorceAlimony.text}
              altTitle={guidebookDivorceContent.guidebookDivorceAlimony.altTitle}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookDivorceContent.guidebookDivorceChildren.linkTo}
              image={guidebookDivorceContent.guidebookDivorceChildren.image}
              headline={guidebookDivorceContent.guidebookDivorceChildren.headline}
              text={guidebookDivorceContent.guidebookDivorceChildren.text}
              altTitle={guidebookDivorceContent.guidebookDivorceChildren.altTitle}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookDivorceContent.guidebookDivorcePropertyScheme.linkTo}
              image={guidebookDivorceContent.guidebookDivorcePropertyScheme.image}
              headline={guidebookDivorceContent.guidebookDivorcePropertyScheme.headline}
              text={guidebookDivorceContent.guidebookDivorcePropertyScheme.text}
              altTitle={guidebookDivorceContent.guidebookDivorcePropertyScheme.altTitle}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookDivorceContent.guidebookDivorceCourtHearing.linkTo}
              image={guidebookDivorceContent.guidebookDivorceCourtHearing.image}
              headline={guidebookDivorceContent.guidebookDivorceCourtHearing.headline}
              text={guidebookDivorceContent.guidebookDivorceCourtHearing.text}
              altTitle={guidebookDivorceContent.guidebookDivorceCourtHearing.altTitle}
            />
          </Grid>
        </Grid>
        <br />
      </TextContainer>
    </Layout>
  );
};
